module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_8019.cabdc9b1.png";